import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useGenerationMode } from "@/app";
import { cn } from "@/shared/lib/utils";
import styles from "./GenerationModeToggle.module.scss";
/**
 * Переключатель режима экрана генерации: классический пошаговый ⇄ чат.
 * Состояние хранится в GenerationModeProvider (localStorage). Доступен и на
 * вебе (сайдбар), и в мини-аппе (шапка экрана генерации).
 */
export const GenerationModeToggle = ({ language, className, }) => {
    const { generationMode, setGenerationMode } = useGenerationMode();
    const ru = language === "ru";
    return (_jsxs("div", { className: cn(styles.toggle, className), role: "tablist", "aria-label": ru ? "Режим генерации" : "Generation mode", children: [_jsx("button", { type: "button", role: "tab", "aria-selected": generationMode === "classic", className: cn(styles.pill, generationMode === "classic" && styles.active), onClick: () => setGenerationMode("classic"), children: ru ? "Классика" : "Classic" }), _jsx("button", { type: "button", role: "tab", "aria-selected": generationMode === "chat", className: cn(styles.pill, generationMode === "chat" && styles.active), onClick: () => setGenerationMode("chat"), children: ru ? "Чат" : "Chat" })] }));
};
